module.exports = __webpack_public_path__ + "img/public/SiteIcons/youtubeIconBlack.svg?939d7372";